import { render, staticRenderFns } from "./DisabledButtons.vue?vue&type=template&id=3e033a58"
import script from "./DisabledButtons.vue?vue&type=script&lang=js"
export * from "./DisabledButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports